import React, { Suspense } from "react";

const CompanyDetails = React.lazy(() => import("@/pages/company-details"));

export default function CompanyDetailsContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <CompanyDetails />
    </Suspense>
  );
}
